var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5551 93.6175L59.6776 70.7625L52.8001 93.6175L47.0551 91.8875L56.8051 59.4875H62.5501L72.3001 91.8875L66.5551 93.6175Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.535 95.7525H14.8201L55.9801 38.585L42.2426 19.505L47.1126 16L59.6776 33.4525L72.2426 16L77.1126 19.505L63.3751 38.585L104.535 95.7525ZM26.5351 89.7525H92.8226L59.6801 43.72L26.5376 89.7525H26.5351Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3663 79.4071L12 82.0908L18.0015 94.0913L23.3679 91.4075L17.3663 79.4071Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.999 79.4185L95.9972 91.4189L101.364 94.1027L107.365 82.1022L101.999 79.4185Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/Tent.f421edfb.svg";
export { ForwardRef as ReactComponent };